import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import BlockUI from '../../../shared/blockui/BlockUI.tsx';
import {ouTraco} from './documentoInscricao.js';
import useFetch from '../../../../hooks/useFetch.js';
import {URL_INSCRICOES_ARQUIVOS_PROCESSOS} from '../../../../constants/index.js';
import {textoSemRegistros} from '../paginacao.js';

const PARAMS = {};
const SELECIONADOS_INICIAIS = [];
const COMPARATOR_KEYS = ['id'];
const TABLE_CONTAINER_PROPS = {component: 'div'};
const PAGINATE_OPTIONS = {
    resetPageOnRowsChange: true,
    startPage: 0,
    rowsPerPage: 5,
    onChangePage: () => {},
    onChangeRowsPerPage: () => {}
};
const COLUNAS = [
    {label: 'Processo de seleção', field: 'descricao', filterable: true, valueGetter: valor => ouTraco(valor)},
    {label: 'Programa', field: 'programa.descricao', filterable: true, valueGetter: valor => ouTraco(valor)}
];

/*
 * Processos de seleção liberados para exportação (planilha, fichas, atualização de PS),
 * com seleção única. Usado dentro de Dialog, por isso o container da tabela é um div.
 */
export default function TabelaProcessosSeletivos(props) {
    const {onSelecionar} = props;
    const [fetch, fetchLoading] = useFetch({returnInnerLoadingState: true});
    const [processos, setProcessos] = useState([]);

    useEffect(() => {
        fetch(URL_INSCRICOES_ARQUIVOS_PROCESSOS, PARAMS, setProcessos);
    }, []);

    return (
        <BlockUI loading={fetchLoading}>
            <DataGrid
                rows={processos}
                columns={COLUNAS}
                filter
                filterOptions={{filterByColumn: true}}
                paginate
                paginateOptions={PAGINATE_OPTIONS}
                select
                selectOptions={{
                    mode: 'single',
                    selectedRows: SELECIONADOS_INICIAIS,
                    onSelect: processo => onSelecionar(processo)
                }}
                comparatorKeys={COMPARATOR_KEYS}
                tableContainerProps={TABLE_CONTAINER_PROPS}
                noRecordsText={textoSemRegistros(fetchLoading, 'Nenhum processo de seleção disponível.')}/>
        </BlockUI>
    );
}

TabelaProcessosSeletivos.propTypes = {
    /* Recebe o processo escolhido: {id, descricao, programa: {id, descricao}}. */
    onSelecionar: PropTypes.func.isRequired
};
